/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import moment from 'moment-timezone';

class CommentForm extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.setNewMemo = this
            .setNewMemo
            .bind(this);

        this.saveMemo = this
            .saveMemo
            .bind(this);
    }
    setNewMemo(e) {
        const {accountActions, orderId} = this.props;
        accountActions.setNewMemo(e.target.value, orderId);
    }

    saveMemo(e, timestamp = moment()) {
        e.preventDefault();

        const {accountActions, orderId, memoRequest, userId, techId} = this.props;

        const newMemoRequest = memoRequest;

        newMemoRequest.memo = `(${userId} techId: ${techId} at ${moment
            .tz(timestamp, "America/Chicago")
            .format('l LT z')}) ${memoRequest
            .memo} `;

        accountActions.addMemoStarted(newMemoRequest, orderId, new Date());

    }
    render() {
        const {memoRequest, memosLoading} = this.props;

        return (
            <div className="row">
                <div className="col s8">
                    <TextField
                        fullWidth
                        disabled={memosLoading}
                        hintText="Enter memo"
                        floatingLabelText="Add New Memo"
                        onChange={this.setNewMemo}
                        multiLine={true}
                        value={memoRequest.memo}
                        rows={2}/>

                </div>

                <div className="col s4">
                    <RaisedButton
                        style={{
                        marginTop: '45px'
                    }}
                        id="wow-fst-add-memo-button"
                        disabled={!memoRequest.memo || memosLoading}
                        fullWidth
                        label="Add"
                        primary={true}
                        onTouchTap={this.saveMemo}/>
                </div>
            </div>
        );
    }
}

CommentForm.propTypes = {
    accountActions: PropTypes.object,
    memoRequest: PropTypes.object,
    orderId: PropTypes.string,
    userId: PropTypes.string,
    memosLoading: PropTypes.bool,
    techId: PropTypes.string

};
export default CommentForm;



// WEBPACK FOOTER //
// ./src/components/comment/CommentForm.js